// extracted by mini-css-extract-plugin
module.exports = {"geoNotification":"geolocation_geoNotification__RJFeW"};